export default __webpack_public_path__ + "static/media/minus_gray.3f5f511f.svg";